export enum AutomedicTimelineView {
  MULTI_MONTH_VIEW = 'MULTI MONTH VIEW',
  MONTH_VIEW = 'MONTH VIEW',
  WEEK_VIEW = 'WEEK VIEW',
  MULTI_DAY_VIEW = 'MULTI DAY VIEW',
}

export const AutomedicTimelineViewLabel: Record<AutomedicTimelineView, string> =
  {
    [AutomedicTimelineView.MULTI_MONTH_VIEW]: 'MULTI MONTH VIEW',
    [AutomedicTimelineView.MONTH_VIEW]: 'MONTH VIEW',
    [AutomedicTimelineView.WEEK_VIEW]: 'WEEK VIEW',
    [AutomedicTimelineView.MULTI_DAY_VIEW]: 'MULTI DAY VIEW',
  };

export const ObservationGroupType = 'Observations';
